export default __webpack_public_path__ + "static/media/ilus6.8975c45a.jpeg";